/* eslint-disable react/jsx-no-undef */
import { Field as FinalFormField, useFormState } from 'react-final-form';
import { RenderIf } from 'react-rainbow-components';
import LanguagePicker from 'components/LanguagePicker';
import PhoneListInput from 'components/PhoneListInput';
import CallResponderPicker from 'components/CallResponderPicker';
import ElevenLabsAgentPicker from 'components/ElevenLabsAgentPicker';
import WorkflowPicker from 'components/WorkflowPicker';
import { validateNotEmpty } from 'data/validators';
import formatIntlPhoneNumber from 'data/services/phone/formatter';
import VoicePipelinePicker from 'components/VoicePipelinePicker';
import { FieldsSection, StyledInput } from './styled';
import { FormOpenMode } from './types';

const Field = (props: any) => <FinalFormField parse={(value) => value} {...props} />;

const Fields = ({
    mode = 'create',
    agentId,
    disabledFields = [],
    phoneNumber,
}: {
    phoneNumber?: string;
    mode?: FormOpenMode;
    agentId: string;
    disabledFields?: string[];
}) => {
    const { values } = useFormState();

    return (
        <FieldsSection>
            <RenderIf isTrue={mode === 'edit'}>
                <StyledInput
                    label="Phone Number"
                    labelAlignment="left"
                    borderRadius="semi-square"
                    value={formatIntlPhoneNumber(phoneNumber)}
                    disabled
                />
            </RenderIf>
            <Field
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                component={LanguagePicker}
                name="language"
                label="Language"
                labelAlignment="left"
                borderRadius="semi-square"
                header="Select language"
                required
                languages={['en', 'es']}
                validate={validateNotEmpty('This field is required')}
            />
            <Field
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                component={VoicePipelinePicker}
                name="pipeline"
                label="Pipeline Server"
                labelAlignment="left"
                borderRadius="semi-square"
                header="Select Voice Pipeline Server"
                required
                validate={validateNotEmpty('This field is required')}
            />
            <RenderIf isTrue={values.pipeline === 'elevenlabs'}>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={ElevenLabsAgentPicker}
                    name="params.elevenLabsAgentId"
                    label="ElevenLabs Agent"
                    labelAlignment="left"
                    borderRadius="semi-square"
                    header="Select ElevenLabs Agent"
                    required
                    validate={validateNotEmpty('This field is required')}
                />
            </RenderIf>
            <RenderIf isTrue={values.pipeline === 'workflow'}>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={WorkflowPicker}
                    name="params.workflowId"
                    label="Workflow"
                    labelAlignment="left"
                    borderRadius="semi-square"
                    required
                    validate={validateNotEmpty('This field is required')}
                    agentId={agentId}
                />
            </RenderIf>
            <RenderIf isTrue={!!values.pipeline && values.pipeline !== 'workflow'}>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={CallResponderPicker}
                    name="params.personaId"
                    label="AI Persona"
                    labelAlignment="left"
                    borderRadius="semi-square"
                    header="Select AI Persona"
                    required
                    validate={validateNotEmpty('This field is required')}
                    agentId={agentId}
                    direction={['inbound']}
                />
            </RenderIf>
            <RenderIf isTrue={!disabledFields.includes('phoneNumber')}>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={PhoneListInput}
                    label="Phone Number"
                    name="phoneNumber"
                    required
                    validate={validateNotEmpty('This field is required')}
                />
            </RenderIf>
        </FieldsSection>
    );
};

export default Fields;
